// extracted by mini-css-extract-plugin
export default {"preview":"QRX5Gn5wEs","item":"x7mFbmYMUq","header":"tqGareNL4h","name":"mbisGq1ugc","copy":"TO0MUBWldz","copied":"uzYG0FksaG","control":"LujW5ouXOH","dark":"RTpqUVbLci"};